import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 掛金納付対象職員届参照API
import {
  IAPI_PRE007_Request,
  IAPI_PRE007_Response,
  IAPI_PRE008_Request,
  IAPI_PRE008_Response,
} from "../../../type/apiType";

// 掛金納付対象職員届更新API
import {
  IAPI_PRE006_Request,
  IAPI_PRE006_Response,
} from "../../../type/apiType";

// 掛金納付対象職員届参照
// API仕様書_掛金
const httpAPI_PRE008 = async (
  param: IAPI_PRE008_Request
): Promise<IAPI_PRE008_Response> => {
  let res = await http.post(ApiUrl.API_PRE008, {
    ...param,
  });

  return res.data;
};

/**
 * 掛金納付対象職員届作成参照API
 * @return httpPremiumApplicationCreate
 */
const httpAPI_PRE007 = async (
  param: IAPI_PRE007_Request
): Promise<IAPI_PRE007_Response> => {
  let res = await http.post(ApiUrl.API_PRE007, {
    ...param,
  });

  return res.data;
};
// 掛金納付対象職員届更新
// API仕様書_掛金
const httpAPI_PRE006 = async (
  param: IAPI_PRE006_Request
): Promise<IAPI_PRE006_Response> => {
  let res = await http.post(ApiUrl.API_PRE006, {
    ...param,
  });

  return res.data;
};

export { httpAPI_PRE008, httpAPI_PRE007, httpAPI_PRE006 };
